import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/asset/:id",
      name: "asset",
      component: () =>
        import("./views/Asset.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/report",
      name: "report",
      component: () =>
        import("./views/Report.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import("./views/Login.vue")
    }
  ],
  mode: 'history'
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        user = data;
        if (typeof to.meta.role !== 'undefined') { // Roles
          let userRoles = user.signInUserSession.accessToken.payload['cognito:groups']
          let role = to.meta.role
          let authorised = false
          for (var i = 0; i < userRoles.length; i++) {
            if (role === userRoles[i]) {
              authorised = true
            }
          }
          if (!authorised) {
            next({ path: '/login' });
          }
        }
      }
      next()
    }).catch((e) => {
      next({ path: '/login' });
    });
  }
  next()
})

export default router